var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgUploadCloud = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7008 13.8143V20.5491C12.7008 20.9368 12.3865 21.2512 11.9987 21.2512C11.611 21.2512 11.2967 20.9368 11.2967 20.5491V13.8143L8.75602 16.3652C8.48185 16.6394 8.03734 16.6394 7.76317 16.3652C7.48901 16.091 7.48901 15.6465 7.76317 15.3724L11.5074 11.6281C11.7816 11.354 12.2261 11.354 12.5003 11.6281L16.2445 15.3724C16.5187 15.6465 16.5187 16.091 16.2445 16.3652C15.9704 16.6394 15.5258 16.6394 15.2517 16.3652L12.7008 13.8143ZM10.1198 3.0531C13.3057 3.41686 15.9682 5.60151 16.9655 8.6143H17.6207C20.0806 8.61593 22.2264 10.2851 22.8332 12.669C23.44 15.053 22.3533 17.5449 20.1935 18.7224C19.853 18.908 19.4266 18.7824 19.241 18.442C19.0554 18.1016 19.1809 17.6752 19.5214 17.4896C21.1178 16.6193 21.921 14.7774 21.4725 13.0154C21.024 11.2533 19.438 10.0196 17.6202 10.0184H16.4408C16.1207 10.0184 15.8412 9.80194 15.7611 9.49208C15.0579 6.77225 12.7517 4.76682 9.96054 4.44813C7.16941 4.12944 4.47046 5.56339 3.17228 8.0547C1.8741 10.546 2.24508 13.5796 4.10535 15.6847C4.3621 15.9753 4.33471 16.4189 4.04417 16.6757C3.75363 16.9324 3.30997 16.905 3.05321 16.6145C0.80806 14.0739 0.360325 10.4126 1.92709 7.40586C3.49386 4.3991 6.75122 2.66848 10.1198 3.0531Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }));
};
export default SvgUploadCloud;